import "./index.css";

const Loader = () => {
  const getAbsoluteHeight = (selector) => {
    const el = document.querySelector(selector);
    if (!el) {
      return window.innerHeight;
    }

    const styles = window.getComputedStyle(el);
    const margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

    return Math.ceil(el.offsetHeight + margin);
  };

  const header = getAbsoluteHeight(".sh-header-section");
  const nav = getAbsoluteHeight(".sh-nav-tab-section");
  const footer = getAbsoluteHeight(".sh-footer-section");
  let containerHeight = 0;
  if (header && nav && footer) {
    containerHeight = window.innerHeight - (header + nav + footer);
  }
  if (containerHeight === 0) {
    containerHeight = 10;
  }

  return (
    <div className="container" style={{ height: containerHeight + "px" }}>
      <div className="row sh-loader">
        <div className="col-md-12 text-center">
          <div className="overlay">
            <div className="overlay__inner">
              <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LoaderInner = () => {
  return (
    <div className="container" style={{ height: "100%" }}>
      <div className="row sh-loader">
        <div className="col-md-12 text-center">
          <div className="overlay">
            <div className="overlay__inner">
              <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LoaderContent = () => {
  const getAbsoluteHeight = (selector) => {
    const el = document.querySelector(selector);
    if (!el) {
      return window.innerHeight;
    }

    var styles = window.getComputedStyle(el);
    var margin = parseFloat(styles["marginTop"]) + parseFloat(styles["marginBottom"]);

    return Math.ceil(el.offsetHeight + margin);
  };

  const header = getAbsoluteHeight(".sh-header-section");
  const nav = getAbsoluteHeight(".sh-nav-tab-section");
  const search = getAbsoluteHeight(".sh-search-section");
  const footer = getAbsoluteHeight(".sh-footer-section");
  let containerHeight = 0;
  if (header && nav && search && footer) {
    containerHeight = window.innerHeight - (header + nav + search + footer);
  }
  if (containerHeight === 0) {
    containerHeight = 10;
  }

  return (
    <div className="container" style={{ height: containerHeight + "px" }}>
      <div className="row sh-loader">
        <div className="col-md-12 text-center">
          <div className="overlay">
            <div className="overlay__inner">
              <div className="lds-roller">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const LoaderSearch = () => {
  return (
    <div className="sh-loader-search">
      <div className="text-center">
        <div className="lds-facebook">
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>
    </div>
  );
};

const LoaderCard = () => {
  return (
    <div className="lds-grid">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
};

export { Loader, LoaderInner, LoaderSearch, LoaderContent, LoaderCard };
